import script from "./SelectFolderView.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectFolderView.vue?vue&type=script&setup=true&lang=js"

import "./SelectFolderView.vue?vue&type=style&index=0&id=0b67a4a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b67a4a6"]])

export default __exports__